import { CompanyGroupApi } from './companyGroupApi'

export const CompanyGroupService = {
    list: () => CompanyGroupApi.list().then(response => response.data),
    create: companyGroupData => CompanyGroupApi.create(companyGroupData).then(response => response.data),
    getStatus: (companyGroup) => CompanyGroupApi.getStatus(companyGroup).then(response => response.data)
}
